/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import moment from 'moment';

export function toFormattedDateString(when: Date, f: string): string {
  return moment(when).format(f);
}

export function toFormattedMonthString(when: number, what: string, f: string): string {
  return moment(when, what).format(f);
}

export function addDays(date: Date, days: number): Date {
  const oldDate = new Date(date); // make sure it's an actual Date and not a moment
  const newDate = new Date(date);
  newDate.setDate(oldDate.getDate() + days);
  return newDate;
}

export function formatAsString(dateValue: string | Date | moment.Moment, format: string = 'YYYY-MM-DD'): string {
  if (dateValue == null) {
    return '';
  }

  let workingValue: moment.Moment;
  if (typeof dateValue === 'string') {
    workingValue = moment(dateValue);
  } else if (typeof dateValue === 'object') {
    workingValue = moment(dateValue);
  } else {
    workingValue = dateValue;
  }

  return workingValue.format(format);
}

export function getCurrentDate() {
  return new Date(Date.parse(Date()));
}

export function getAdjustedCurrentDate(seconds: number): Date {
  const now = moment(Date());

  const adjustedDate = now.add(seconds, 'seconds');
  return adjustedDate.toDate();
}
